import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { SessionContext } from '../context/SessionContext';
// --- 1. SE IMPORTA EL HOOK PARA SABER QUÉ RESTAURANTE ESTÁ SELECCIONADO ---
import { useRestaurant } from '../context/RestaurantContext';
import './NewOrder.css';

const NewOrder = () => {
  const navigate = useNavigate();
  const { sessionId } = useContext(SessionContext);
  // --- 2. SE OBTIENE EL RESTAURANTE SELECCIONADO ---
  const { selectedRestaurant } = useRestaurant();
  const [customerName, setCustomerName] = useState('');
  const [deliveryType, setDeliveryType] = useState('Recoger en local');
  const [address, setAddress] = useState('');
  const [items, setItems] = useState([{ quantity: 1, name: '', notes: '' }]);
  const [total, setTotal] = useState('');

  const handleItemChange = (index, event) => {
    const values = [...items];
    values[index][event.target.name] = event.target.value;
    setItems(values);
  };

  const handleAddItem = () => {
    setItems([...items, { quantity: 1, name: '', notes: '' }]);
  };

  const handleRemoveItem = (index) => {
    if (items.length > 1) {
      const values = [...items];
      values.splice(index, 1);
      setItems(values);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // --- 3. SE AÑADE UNA VALIDACIÓN IMPORTANTE ---
    if (!selectedRestaurant) {
        alert("Error: No se ha seleccionado un restaurante. Por favor, vuelve al inicio y selecciona uno.");
        return;
    }
    if (!customerName || items.some(item => !item.name)) {
      alert('Por favor, completa el nombre del cliente y al menos un producto.');
      return;
    }

    const now = new Date();
    const hora = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');

    const newOrder = {
      customer_name: customerName,
      delivery_type: deliveryType,
      address: deliveryType === 'A domicilio' ? address : '',
      status: 'Pendiente', // Todas las órdenes nuevas inician como 'Pendiente'
      hora: hora,
      timestamp: serverTimestamp(),
      items: items.map(item => ({
        ...item,
        quantity: Number(item.quantity)
      })),
      createdBySession: sessionId,
      total: total ? Number(total) : 0,
      // --- 4. SE AÑADE LA ETIQUETA DEL RESTAURANTE A LA ORDEN ---
      restaurantId: selectedRestaurant 
    };

    try {
      await addDoc(collection(db, 'orders'), newOrder);
      navigate('/'); 
    } catch (error) {
      console.error("Error al guardar la orden: ", error);
      alert('Hubo un error al guardar la orden.');
    }
  };

  return (
    <div className="new-order-container">
      <h2>Crear Nueva Orden</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nombre del Cliente</label>
          <input
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Tipo de Orden</label>
          <select value={deliveryType} onChange={(e) => setDeliveryType(e.target.value)}>
            <option value="Recoger en local">Recoger en local</option>
            <option value="A domicilio">A domicilio</option>
            <option value="Apartado en local">Apartado en local</option>
          </select>
        </div>

        {deliveryType === 'A domicilio' && (
          <div className="form-group">
            <label>Dirección de Entrega</label>
            <input
              type="text"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              required
            />
          </div>
        )}

        <h3>Productos</h3>
        {items.map((item, index) => (
          <div key={index} className="item-row">
            <input
              type="number"
              name="quantity"
              placeholder="Cant."
              value={item.quantity}
              onChange={e => handleItemChange(index, e)}
              className="input-qty"
              min="1"
              required
            />
            <input
              type="text"
              name="name"
              placeholder="Nombre del Producto"
              value={item.name}
              onChange={e => handleItemChange(index, e)}
              className="input-name"
              required
            />
            <input
              type="text"
              name="notes"
              placeholder="Notas (ej: sin cebolla)"
              value={item.notes}
              onChange={e => handleItemChange(index, e)}
              className="input-notes"
            />
            {items.length > 1 && (
              <button type="button" className="remove-item-btn" onClick={() => handleRemoveItem(index)}>
                -
              </button>
            )}
          </div>
        ))}
        <button type="button" className="add-item-btn" onClick={handleAddItem}>
          + Añadir Producto
        </button>

        <div className="form-group total-amount-group">
          <label>Monto Total (Opcional)</label>
          <input
            type="number"
            placeholder="0.00"
            step="0.01"
            value={total}
            onChange={(e) => setTotal(e.target.value)}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-btn">Guardar Orden</button>
          <button type="button" className="cancel-btn" onClick={() => navigate('/')}>Cancelar</button>
        </div>
      </form>
    </div>
  );
};

export default NewOrder;